import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { categoriesNewService } from '../services/categoriesNew.service';
import type { CategoryFormValues } from '../types/categoriesNew.types';

export function useCategoriesNew() {
  const queryClient = useQueryClient();
  const { profile } = useAuth();
  const userId = profile?.id || '';
  const companyId = profile?.company_id || '';

  const lookupsQuery = useQuery({
    queryKey: ['settings1', 'categories', 'new', 'lookups'],
    queryFn: () => categoriesNewService.getLookups(),
  });

  const createMutation = useMutation({
    mutationFn: (values: CategoryFormValues) => categoriesNewService.createCategory(values, userId, companyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings1', 'categories'] });
    },
  });

  return {
    lookups: lookupsQuery.data,
    isLoadingLookups: lookupsQuery.isLoading,
    createCategory: createMutation.mutateAsync,
    isSaving: createMutation.isPending,
  };
}

